module.exports = __webpack_public_path__ + "static/WEDDING E&M-491-7b23c2c1d76eefe32e5d88a653878ba4.jpg";